<template>
  <el-drawer title="电话联系记录" :visible.sync="drawer" size="50%" :before-close="handleClose">
    <div class="m-tabs-content">
      <call-logs :company="callCompany" :phone="callPhone" :phone1="callPhone1" :phone2="callPhone2" :phone3="callPhone3" />
    </div>
  </el-drawer>
</template>

<script>
import CallLogs from 'common/CallLogs'
export default {
  name: 'RisksDrawer',
  components: { CallLogs },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    callCompany: {
      type: String,
      default: ''
    },
    callPhone: {
      type: Array,
      default: () => {
        return []
      }
    },
    callPhone1: {
      type: Array,
      default: () => {
        return []
      }
    },
    callPhone2: {
      type: Array,
      default: () => {
        return []
      }
    },
    callPhone3: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
  },
  watch: {
  },
  data () {
    return {
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose', false)
    }
  }
}
</script>
<style lang="stylus" scoped>
.el-drawer__wrapper >>> .el-drawer__body {
  overflow-y: auto
}
* >>> .el-drawer__header {
  color: #409eff;
  font-size: medium;
}
.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}
.risks {
  border: 1px solid #D8DDE5;
}
.risks-span {
  line-height: .4rem;
  padding: 10px 12px 10px;
}
.bg {
  background: #f3f7ff;
}
.m-tabs-content >>> .el-card__body {
  padding: 0;
}
.box-card {
  margin-bottom: .2rem;
  border-top: 1px solid #86B9D6;
}
.tr {
  text-align: right;
}
.span-flex {
  display: flex;
  align-items: center;
  justify-content: right;
  color: rgb(13, 88, 165);
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyCallLogsDrawer.vue